import { Validator } from '@vista-digital/validator';
export const defaultCdnConfig = {
    vista: {
        url: undefined
    }
};
const vistaProviderConfigurationValidator = Validator.object({
    url: Validator.nonEmptyString,
    mediaApiToken: Validator.optional(Validator.nonEmptyString)
});
const moviexchangeProviderConfigurationValidator = Validator.object({
    url: Validator.nonEmptyString
});
export const cdnConfigValidator = Validator.object({
    vista: vistaProviderConfigurationValidator,
    moviexchange: Validator.optional(moviexchangeProviderConfigurationValidator)
});
//# sourceMappingURL=cdn.js.map